import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postForecastHistoryDownloadRequest = createApi(`postForecastHistoryDownloadSlice`, "POST");

const postForecastHistoryDownloadSlice = createSlice({
  name: 'postForecastHistoryDownloadSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postForecastHistoryDownloadRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postForecastHistoryDownloadRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postForecastHistoryDownloadRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default postForecastHistoryDownloadSlice.reducer;
